/* eslint-disable react-refresh/only-export-components */
import { ColumnHelper, Row } from "@tanstack/react-table";
import classNames from "classnames";
import { ActionIcon } from "PFComponents/action_icon";

import { TableData } from "../table";
import { useRowDragHandle } from "./row_drag_handle_context";
import css from "./table_drag_handle_column.module.scss";

export type IsRowDragDisabledFn<TABLE_DATA extends TableData> = (row: Row<TABLE_DATA>) => boolean;

type RowDragHandleProps = {
  qaId?: string;
  disabled?: boolean;
};

const RowDragHandle = ({ qaId, disabled }: RowDragHandleProps) => {
  const { attributes, listeners } = useRowDragHandle();

  return (
    <div className={css.dragHandleCell}>
      <ActionIcon
        name="arrow-2-directions-vertical"
        size="xxs"
        classes={{ root: classNames({ [css.grabCursor]: !disabled }) }}
        disabled={disabled}
        qaId={qaId}
        {...listeners}
        {...attributes}
      />
    </div>
  );
};

export const generateDragHandleColumn = <TABLE_DATA extends TableData>(
  columnHelper: ColumnHelper<TABLE_DATA>,
  enableRowReordering: boolean,
  isRowDragDisabled: IsRowDragDisabledFn<TABLE_DATA>
) => {
  if (!enableRowReordering) {
    return null;
  }

  return columnHelper.accessor((row) => row, {
    id: "drag-handle",
    enableSorting: false,
    header: () => null,
    cell: ({ row }) => (
      <RowDragHandle qaId={`RowDragHandle.${row.original?.id ?? row.id}`} disabled={isRowDragDisabled(row)} />
    ),
    size: 32
  });
};
